import { AccountApplicationContextProvider } from './account-application/account-application-context-provider';
import { AccountApprovalContextProvider } from './account-approval/account-approval-context-provider';
import { GuaranteedSessionContextProvider } from './session/session-context-provider';

interface AppContextProviderProps {
    children: React.ReactNode;
}

export const AppContextProvider = ({ children }: AppContextProviderProps) => (
    <GuaranteedSessionContextProvider>
        <AccountApplicationContextProvider>
            <AccountApprovalContextProvider>{children}</AccountApprovalContextProvider>
        </AccountApplicationContextProvider>
    </GuaranteedSessionContextProvider>
);
